"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseValidStringToDate = void 0;
const regex_1 = require("./regex");
const parseValidStringToDate = (stringDate) => {
    if (stringDate.match(regex_1.validDateFormat)) {
        const parts = stringDate.split('/');
        return new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
    }
    return undefined;
};
exports.parseValidStringToDate = parseValidStringToDate;
//# sourceMappingURL=functions.js.map